import { getLocalTranslation } from '../utils/i18nKit';
export var getPropertyCoverQuestionConstantTextMap = function getPropertyCoverQuestionConstantTextMap() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return {
    temporaryPlacementUnderStandardContract: {
      title: $t('kit:are_all_temporary_placements_under_standard_contract'),
      brief_desc_1: $t('kit:clause_stating_supervision_direction_control'),
      brief_desc_2: $t('kit:standard_contracts_hold_harmless_agreement'),
      percent_question: $t('kit:what_percentage_temporary_placements_not_standard')
    },
    officeContentsSumInsured: {
      title: $t('kit:sum_insured_office_content_excluding_computer'),
      total_desc: $t('kit:total_office_content_to_insure_excluding_computer'),
      checkbox_desc: $t('kit:do_not_cover_office_content')
    },
    computerEquipmentContentsSumInsured: {
      title: $t('kit:sum_insured_computer_equipment'),
      total_desc: $t('kit:total_computer_equipment_to_insure_excluding_other'),
      checkbox_desc: $t('kit:do_not_cover_computer_equipment')
    },
    businessInterruptionInsured: {
      title: $t('kit:sum_insured_increased_cost_working_business_interruption'),
      desc: $t('kit:increased_cost_working_covers_additional_expenses')
    },
    computersAndEquipementInsured: {
      title: $t('kit:total_value_portable_equipment_use_business_globally'),
      desc: ''
    }
  };
};